import { createContext } from 'react';

const PermissionProvider = createContext();

export default PermissionProvider;
